<template lang="pug">
  include ./../../../mixins
  div(
    :class="tabClass"
  )
    +b.tabs
      +e.elements.g-cols--3-md.--n_height
        +e.item(
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{'tabs__item--isactive': tab.isActive}"
          @click="selectTab(tab)"
        )
          +e.name.P {{ tab.name }}
      +e.details.g-cols--auto-md
        slot()
</template>

<script>
export default {
  name: 'TabsUi',

  props: {
    tabClass: {
      type: String,
      default: 'tabs',
    },
  },

  created() {
    this.tabs = this.$children
  },

  data() {
    return {
      tabs: [],
    }
  },

  methods: {

    /**
       * The selected tab is activated here.
       *
       * @param {Object} selectedTab -
       * UI CONTAINER / DOM ELEMENT.
       *
       */
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        // eslint-disable-next-line no-param-reassign,eqeqeq
        tab.isActive = (tab.name == selectedTab.name)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiTabs/TabsUi.vue